import { SingleSite } from '@/core/entities';
import { FunctionComponent, ReactElement, useMemo } from 'react';
import LocationManagementBase, { LocationsManagementBaseProps } from './LocationsManagementBase';

export interface LocationsManagementProps extends LocationsManagementBaseProps {
	site: SingleSite;
}

const LocationsManagement: FunctionComponent<LocationsManagementProps> = ({
	site,
	level,
	parentLocationId,
	header,
	table,
	invalidateData,
}): ReactElement => {
	const terminalLevel = useMemo(
		() =>
			site.levels?.reduce((previousLevel, currentLevel) =>
				previousLevel.order > currentLevel.order ? previousLevel : currentLevel
			),
		[site]
	);
	const isLevelTerminalLevel = useMemo(
		() => level?.id === terminalLevel?.id,
		[level, terminalLevel]
	);

	return (
		<LocationManagementBase
			site={site}
			level={level}
			parentLocationId={parentLocationId}
			header={header}
			table={{ ...table, rowAction: isLevelTerminalLevel ? undefined : table.rowAction }}
			invalidateData={invalidateData}
		/>
	);
};

export default LocationsManagement;
